module.exports = __webpack_public_path__ + "img/40_00_075_281.d0be80c1.jpg";